/**
 * デジタルサイネージ表示設定管理用モジュール。
 *
 * @module app/signage/SignageAdminPage
 */
define(['module',
        'dojo/_base/declare',
        'dojo/_base/lang',
        'dojo/topic',
        'dojo/text!./templates/SignageAdminPage.html',
        'idis/model/UserInfo',
        'idis/control/Router',
        'idis/store/IdisRest',
        'idis/view/Loader',
        'idis/view/page/_PageBase',
        'idis/view/dialog/DialogChain',
        './_SignageDialogBase',
        './consts/DisplayType',
        'dojo/dom-style',
        // 以下、変数で受けないモジュール
        'dijit/Dialog',
        'dijit/form/Form',
        'dijit/layout/BorderContainer',
        'dijit/layout/ContentPane',
        'idis/view/form/AclButton',
        './SignageAdminPageGrid',
        './SignageRegisterDialog',
        './SignageDetailDialog'
], function(module, declare, lang, topic, template, UserInfo,
        Router, IdisRest, Loader, _PageBase, DialogChain, _SignageDialogBase, DisplayType, domStyle) {
        /**
         *
         * @class SignageAdminPage
         * @extends module:idis/view/page/_PageBase~_PageBase
         */
        return declare(module.id.replace(/\//g, '.'), _SignageDialogBase,
        /** @lends module:app/signage/SignageAdminPage~SignageAdminPage# */
        {
            // テンプレート文字列
            templateString: template,
            
            store: null,
            
            // ルート要素に付与されるCSS
            baseClass: 'idis-Page idis-Page--signage',
            
            /**
             * 変数初期化メソッド
             */
            constructor: function() {
                // グループ管理タブ用データ格納用オブジェクト
                this.store = new IdisRest({
                    idProperty:'screenId',
                    target: '/api/signage',
                    sortParam: 'sort',
                    rangeStartParam: 'start',
                    rangeCountParam: 'count'
                });
                // ダイアログ連鎖を登録
                this.chain = DialogChain.get(this);
            },
            
            buildRendering: function() {
                this.inherited(arguments);
                this.own(this.innerSignageRegisterDialog);
                this.own(this.innerSignageDetailDialog);
            },
            
            startup: function() {
                this.inherited(arguments);

                this.initGrid();
                this.initPage();
            },

            /**
             * Gridを初期化する。
             */
            initGrid: function() {
                // gridに一覧を設定する
                this.signageAdminPageGrid.set('collection', this.store);

                // グリッドの詳細ボタンクリック時の動作を設定する
                // helper.buttonColumnでフィールド名に指定した'detail'と'ButtonClick'の結合がボタンクリック時のイベント名
                this.signageAdminPageGrid.on('detailButtonClick', lang.hitch(this, function(evt) {
                    this.showDetaiDialog(evt.item);
                }));

                this.signageAdminPageGrid.on('showMapSettingPage', lang.hitch(this, function(evt) {
                    this.showMapSettingPage(evt.item);
                }));
            },

            initPage: function() {
        	    // 登録ダイアログを初期化
                this.initRegisterDialog();
        	    // 詳細ダイアログを初期化
                this.initDetailDialog();
                // 権限によって画面表示を変更
                this.setScreenStatus();
            },

            /**
             * ユーザに応じて新規登録ボタン、詳細ボタンを非表示にする。
             */
            setScreenStatus: function() {
                // 役割を取得
                var role = UserInfo.getRoleCd();
                this.resetScreenStatus();
                // 管理ユーザ、県・危機管理・管理ユーザ、県・危機管理・一般ユーザの場合は表示させる
                if (UserInfo.isSysAdmin() || role === 'R01011' || role === 'R01012') {
                    domStyle.set(this.registerArea, 'display', '');
                }
            },

            /**
             * 新規登録ボタン、詳細ボタンを初期化する。
             */
            resetScreenStatus: function() {
                domStyle.set(this.registerArea, 'display', 'none');
            },

            /**
             * 登録画面に遷移する。
             */
            showRegisterDialog: function() {
                this.innerSignageRegisterDialog.initDialog();
                this.registerDialog.show();
            },

            /**
             * @param item gridのstore1行分
             * 詳細画面に遷移する。
             */
            showDetaiDialog: function(item) {
                this.innerSignageDetailDialog.initDialog(item);
                this.detailDialog.show();
            },

            /**
             * @param item gridのstore1行分
             * 地図設定画面に遷移する。
             */
            showMapSettingPage: function(item) {
                Router.moveTo('signageMapSetting', {
                    screenId : item.screenId
                });
            },

            /**
             * サイネージ画面（複数選択）を表示する。
             */
            onDisplaySignageButtonClick: function() {
                var selection = this.signageAdminPageGrid.selection;
                if (Object.keys(selection).length === 0) {
                    this.chain.info('表示対象が選択されていません。', 'エラー');
                    return;
                }
                var signage = [];
                var keys = Object.keys(selection).reverse();
                for (var i = 0, len = keys.length; i < len; i++) {
                    var displayType = this.signageAdminPageGrid._rowIdToObject['signageAdminPageGrid-row-' + keys[i]].displayType;
                    var displayName = this.signageAdminPageGrid._rowIdToObject['signageAdminPageGrid-row-' + keys[i]].displayName;
                    var updFreq = this.signageAdminPageGrid._rowIdToObject['signageAdminPageGrid-row-' + keys[i]].updFreq;
                    signage.push({'screenId':keys[i], 'page':DisplayType[displayType], 'title':displayName, 'frequency':updFreq, 'displayType':displayType});
                }
                // リロード対応のためにセッションストレージに選択対象を保持する。
                sessionStorage.setItem("selectedSignage", JSON.stringify(signage));

                // デジタルサイネージ更新開始
                topic.publish('app/control/SignageControl::start', signage);
            },

            /**
             * 登録ダイアログを初期化する。
             */
            initRegisterDialog: function() {
                var dialog = this.registerDialog;
                var page = dialog.getChildren()[0];

                // 詳細画面のregisterイベントを受け取る
                page.on('register', lang.hitch(this, function(evt) {
					// 追加確認ダイアログを表示
					this.chain.confirmAdd(function (chain) {
                        var form = evt.value;
                        // 追加処理と共にローディング表示
                        Loader.wait(this.store.add(form)).then(lang.hitch(this, function () {
                            // 成功時（POST結果はグリッドが自動的に反映）
                            // 登録ダイアログを閉じる
                            dialog.hide();
                            // 完了ダイアログを表示
                            chain.infoComplete();
                            // 一覧を取得しなおす
                            this.updateGridQuery();
                        }), function(err) {
                            // 失敗時
                            chain.infoError(err);
                        });
                    });
                }));
            },

            /**
             * 詳細ダイアログを初期化する。
             */
            initDetailDialog: function() {
                var dialog = this.detailDialog;
                var page = dialog.getChildren()[0];

                // 詳細画面のremoveイベントを受け取る
                page.on('remove', lang.hitch(this, function(evt) {
                    this.chain.confirmDel(function(chain) {
                        var promise = this.store.remove(evt.value.screenId + '?version=' + evt.value.version);
                        Loader.wait(promise).then(lang.hitch(this, function() {
                            // 登録フォーム・ダイアログを閉じる
                            dialog.hide();
                            chain.infoComplete();
                            // 一覧を取得しなおす
                            this.updateGridQuery();
                        }), function(err) {
                            // 失敗時
                            chain.infoError(err);
                        });
                    });
                }));

                // 詳細画面のupdateイベントを受け取る
                page.on('update', lang.hitch(this, function(evt) {
                    // 追加確認ダイアログを表示
                    this.chain.confirmPut(function(chain) {
                        var form = evt.value;
                        // 追加処理と共にローディング表示
                        Loader.wait(this.store.put(form)).then(lang.hitch(this, function() {
                            // 成功時（POST結果はグリッドが自動的に反映）
                            // 登録ダイアログを閉じる
                            dialog.hide();
                            // 完了ダイアログを表示
                            chain.infoComplete();
                            // 一覧を取得しなおす
                            this.updateGridQuery();
                        }), function(err) {
                            // 失敗時
                            chain.infoError(err);
                        });
                    });
                }));
            },

            updateGridQuery: function() {
                var filter = new this.store.Filter();
                // filterに対応するcollectionを取得
                var collection = this.store.filter(filter);
                // collectionをグリッドにセットする（サーバーにリクエストされる）
                this.signageAdminPageGrid.set('collection', collection);
            }
        });
    });
